'use client';

import React from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';

import { GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function SupportTicketDetailsDrawer(): React.JSX.Element {
  const { drawerState } = useAppSelector(getUi);
  const dispatch = useAppDispatch();

  return (
    <DrawerTemplate
      open={drawerState.SUPPORT_TICKET_DETAILS}
      onClose={() => dispatch(hideDrawerState(GeneralDrawer.SUPPORT_TICKET_DETAILS))}
      title="Chat"
      width="830px"
    >
      {/* <SupportChat /> */}
    </DrawerTemplate>
  );
}
